import React from 'react';

import { ReactComponent as FunnelIcon } from 'assets/images/icons/funnel.svg';
import { ReactComponent as SearchIcon } from 'assets/images/icons/search.svg';
import { ReactComponent as CloseIcon } from 'assets/images/icons/close.svg';

import styles from 'assets/scss/modules/Gateways/Gateways.module.scss';

interface Props {
  search: string;
  filtersOpen: boolean;
  onSearchChange: (value: string) => void;
  onToggleFilters: () => void;
}

export const Toolbar: React.FC<Props> = ({
  search,
  filtersOpen,
  onSearchChange,
  onToggleFilters,
}) => {
  const hasValue = search.length > 0;

  return (
    <div className={styles.toolbar}>
      <div className={styles.searchWrapper}>
        <input
          className={styles.searchInput}
          type="text"
          placeholder="Search gateways..."
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
        />
        {hasValue ? (
          <button
            type="button"
            className={styles.searchClear}
            onClick={() => onSearchChange('')}
            aria-label="Clear search"
          >
            <CloseIcon />
          </button>
        ) : (
          <span className={styles.searchIcon} aria-hidden>
            <SearchIcon />
          </span>
        )}
      </div>

      <button
        type="button"
        className={styles.toolbarButton}
        onClick={onToggleFilters}
        aria-label={filtersOpen ? 'Hide filters' : 'Show filters'}
      >
        {filtersOpen ? <CloseIcon /> : <FunnelIcon />}
      </button>
    </div>
  );
};
